import React from "react";
import APIAdapter from "../APIClient/APIAdapter";
import Constants from "../Constants/Constants";
import LocalStore from "../Storage/LocalStore";
import { AuthContext } from '../App';

export const PortalContext = React.createContext();

export const PortalContextProvider = (props) => {

  const { signOut } = React.useContext(AuthContext);

  const [state, dispatch] = React.useReducer(
    (prevState, action) => {
      switch (action.type) {
        case 'ON_LOAD':
          return {
            ...prevState,
            points: action.points
          };
      }
    },
    {
      points: null
    }
  );

  const logoutUser = (async () => {
    debugger;
    await signOut();
  });

  React.useEffect(() => {
    // Fetch the token from storage then navigate to our appropriate place
    const bootstrapAsync = async () => {
      var balance = 0.00;
      var pointsData = {balance: 0.00, value: (balance / 100).toFixed(2)}
      try {


        var user = JSON.parse(await LocalStore.LoadData("UserData"));
        var authResponse = await APIAdapter.POST_QUADRANET(Constants.kMethodQuadranetLogin, {username: user.quadranetUserName, password:user.quadranetPassword});
        // console.log(authResponse.data)
        APIAdapter.quadToken = authResponse.data;
        var userProfileResponse = await APIAdapter.GET_QUADRANET(Constants.kMethodQuadranetUser);
        // console.log(userProfileResponse)
        
        pointsData = {balance: userProfileResponse.data.points.balance.totalPoints, value: userProfileResponse.data.points.balance.valueOfPointsDisplay}

        // // var response = await APIAdapter.GETTevalis(Constants.kAPIGetPoints)
        // var response = await APIAdapter.GET(Constants.kAPIGetGiftCardBalance);
        // if (response.success) {
        //   balance = response.data.balance
        //   pointsData = {balance: balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), value: (balance / 100).toFixed(2)}
        //   // signOut();
        // }
        // else {
        //   // pointsData = {balance: 0, value: (balance / 100).toFixed(2)}
        // }


      } catch (e) {
        // Restoring token failed
      }
      // After restoring token, we may need to validate it in production apps

      // This will switch to the App screen or Auth screen and this loading
      // screen will be unmounted and thrown away.
      dispatch({ type: 'ON_LOAD', points: pointsData });
    };

    bootstrapAsync();
  }, [props.navigation]);

  return (
    <PortalContext.Provider value={{ ...state, dispatch, signOut }}>
      {props.children}
    </PortalContext.Provider>
  );

};